var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExplore = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 7.266A.731.731 0 0 0 7.267 8 .73.73 0 0 0 8 8.733.731.731 0 0 0 8.733 8 .731.731 0 0 0 8 7.266zm0-5.933A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.666 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333zM9.46 9.46 4 12l2.54-5.46L12 4 9.46 9.46z"
})));
export default SvgExplore;